"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _icUnverifiedLocationLarge = _interopRequireDefault(require("../../../../img/ic-unverified-location-large.svg"));

var _icHoursLarge = _interopRequireDefault(require("../../../../img/ic-hours-large.svg"));

var _nicaLocatorCore = require("../../../nicaLocatorCore");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var daysOfTheWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

var BusinessHours = function BusinessHours(_ref) {
  var location = _ref.location;

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      customHoursIcon = _useContext.images.hoursIcon;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "business-hours-container flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-section-icon-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "business-hours-img",
    src: customHoursIcon || _icHoursLarge.default,
    alt: "hours available icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "business-hours-header headlineFont"
  }, "Hours"), location && location.businessHours && Object.keys(location.businessHours).length ? /*#__PURE__*/_react.default.createElement("div", null, daysOfTheWeek.map(function (day, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex",
      key: "hour-row-" + index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "business-hours-day flex1"
    }, day), _buildDayRow(location, day));
  }), location.businessHoursTemporarilyAffected && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center marginTop15"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight10"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _icUnverifiedLocationLarge.default,
    alt: "unclaimed icon",
    className: "business-hours-temp-img"
  })), /*#__PURE__*/_react.default.createElement("div", null, location.businessHoursTemporaryMessage ? location.businessHoursTemporaryMessage : "Business Hours are temporarily affected"))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "business-hours-empty bodyFont"
  }, "This information is not available yet.")));
};

function _buildDayRow(location, day) {
  if (!location.businessHours[_openKey(day)]) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "business-hours-value business-hours-closed flex1"
    }, "Closed");
  } else {
    var open = _formatTime(location.businessHours[_openKey(day)]);

    var close = _formatTime(location.businessHours[_closeKey(day)]);

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "business-hours-value flex1"
    }, open + " - " + close);
  }
}

function _closeKey(day) {
  return "".concat(day.toLowerCase(), "Close");
}

function _openKey(day) {
  return "".concat(day.toLowerCase(), "Open");
}

function _formatTime(t) {
  var hour, minute;
  var amPM = "AM";

  var _t$split = t.split(":");

  var _t$split2 = _slicedToArray(_t$split, 2);

  hour = _t$split2[0];
  minute = _t$split2[1];
  hour = parseInt(hour, 10);

  if (hour >= 12) {
    hour -= 12;
    amPM = "PM";
  }

  hour = hour || 12;

  if (minute.length === 1) {
    minute = "0" + minute;
  }

  return hour + ":" + minute + " " + amPM;
}

var _default = BusinessHours;
exports.default = _default;